import { currentWallet } from '@cronos-app/wallet';

interface IfConnectedProps {
  children: React.ReactNode;
}

const IfConnected: React.FC<IfConnectedProps> = ({ children }) => {
  const isConnected = currentWallet.useIsConnected();
  if (!isConnected) return null;
  return <>{children}</>;
};

export default IfConnected;
